module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("3.")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle1"
  }, [_vm._v("THE AFFAIR OF THE PINK PEARL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“What on earth are you doing?” demanded Tuppence, as she entered the inner sanctum of the International Detective Agency—(Slogan—Blunt’s "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Brilliant Detectives) and discovered her lord and master prone on the floor in a sea of books.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy struggled to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was trying to arrange these books on the top shelf of that cupboard,” he complained. “And the damned chair gave way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are they, anyway?” asked Tuppence, picking up a volume. “’The Hound of the Baskervilles.’ I wouldn’t mind reading that again some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see the idea?” said Tommy, dusting himself with care. “Half hours with the Great Masters—that sort of thing. You see, Tuppence, I can’t help feeling that we are more or less amateurs at this business—of course amateurs in one sense we cannot help being, but it would do no harm to acquire the technique, so to speak. These books are detective stories by the leading masters of the art. I intend to try different styles, and compare results.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“H’m,” said Tuppence. “I often wonder how those detectives would have got on in real life.” She picked up another volume. “You’ll find a difficulty in being a Thorndyke. You’ve no medical experience, and less legal, and I never heard that science was your strong point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps not,” said Tommy. “But at any rate I’ve bought a very good camera, and I shall photograph footprints and enlarge the negatives and all that sort of thing. Now, mon ami, use your little grey cells—what does this convey to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pointed to the bottom shelf of the cupboard. On it lay a somewhat futuristic dressing gown, a turkish slipper, and a violin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Obvious, my dear Watson,” said Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly,” said Tommy. “The Sherlock Holmes touch.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took up the violin and drew the bow idly across the strings, causing Tuppence to give a wail of agony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that moment the buzzer rang on the desk, a sign that a client had arrived in the outer office and was being held in parley by Albert, the office boy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Tommy hastily replaced the violin in the cupboard and kicked the books behind the desk.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not that there’s any great hurry,” he remarked. “Albert will be handing them out the stuff about my being engaged with Scotland Yard on the phone. Get into your office and start typing, Tuppence. It makes the office sound busy and active. No, on second thoughts, you shall be taking notes in shorthand from my dictation. Let’s have a look before we get Albert to send the victim in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They approached the peephole which had been artistically contrived so as to command a view of the outer office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The client was a girl of about Tuppence’s age, tall and dark with a rather haggard face and scornful eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clothes cheap and striking,” remarked Tuppence. “Have her in, Tommy.” In another minute the girl was shaking hands with the celebrated Mr. Blunt, whilst Tuppence sat by with eyes demurely downcast, and pad and pencil in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My confidential secretary, Miss Robinson,” said Mr. Blunt with a wave of the hand. “You may speak freely before her.” Then he lay back for a minute, half closed his eyes and remarked in a tired tone: “You must find traveling in a bus very crowded at this time of day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I came in a taxi,” said the girl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh!” said Tommy aggrieved. His eyes rested reproachfully on a blue bus ticket protruding from her glove. The girl’s eyes followed his glance, and she smiled and drew it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean this? I picked it up on the pavement. A little neighbor of ours collects them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence coughed, and Tommy threw a baleful glare at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We must get to business,” he said briskly. “You are in need of our services, Miss—?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“Kingston Bruce is my name,” said the girl. “We live at Wimbledon. Last night a lady who is staying with us lost a valuable pink pearl. Mr. St. Vincent was also dining with us, and during dinner he happened to mention ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("your firm. My mother sent me off to you this morning to ask you if you would look into the matter for us.”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The girl spoke sullenly, almost disagreeably. It was clear as daylight that she and her mother had not agreed over the matter. She was here under protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” said Tommy, a little puzzled. “You have not called in the police?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” said Miss Kingston Bruce, “we haven’t. It would be idiotic to call in the police and then find that the silly thing had rolled under the fireplace, or something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh!” said Tommy. “Then the jewel may only be lost after all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Kingston Bruce shrugged her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“People make such a fuss about things,” she murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy cleared his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” he said doubtfully. “I am extremely busy just now—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I quite understand,” said the girl rising to her feet. There was a quick gleam of satisfaction in her eyes which Tuppence, for one, did not miss. “Nevertheless,” continued Tommy, “I think I can manage to run down to Wimbledon. Will you give me the address, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Laurels, Edgeworth Road.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make a note of it, please, Miss Robinson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Kingston Bruce hesitated, then said rather ungraciously:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll expect you then. Good morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Funny girl,” said Tommy. “I couldn’t quite make her out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder if she stole the thing herself,” remarked Tuppence meditatively. “Come on, Tommy, let’s put away these books and take the car and go down there. By the way, who are you going to be, Sherlock Holmes still?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I need practice for that,” said Tommy. “I came rather a cropper over that bus ticket, didn’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did,” said Tuppence. “If I were you I shouldn’t try too much on that girl—she’s as sharp as a needle. She’s unhappy too, poor devil.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose you know all about her already,” said Tommy with sarcasm, “simply from looking at the shape of her nose!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“I’ll tell you my idea of what we shall find at The Laurels,” said Tuppence, quite unmoved. “A household of snobs, very keen to move in the best society; the father, if there is a father, is sure to have a military title. The girl falls in with their way of life and despises herself for doing so.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy took a last look at the books now neatly ranged upon a shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think,” he said thoughtfully, “that I shall be Thorndyke to—day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I shouldn’t have thought there was anything medico—legal about this case,” remarked Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps not,” said Tommy. “But I’m simply dying to use that new camera of mine! It’s supposed to have the most marvelous lens that ever was or ever could be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know those kind of lenses,” said Tuppence. “By the time you’ve adjusted the shutter and stopped down and calculated the exposure and kept your eyes on the spirit level, your brain gives out, and you yearn for the simple Brownie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only an unambitious soul is content with the simple Brownie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I bet I shall get better results with it than you will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy ignored this challenge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ought to have a ‘Smoker’s Companion,’” he said regretfully. “I wonder where one buys them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s always the patent corkscrew Aunt Araminta gave you last Xmas,” said Tuppence helpfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true,” said Tommy. “A curious looking engine of destruction I thought it at the time, and rather a humorous present to get from a strictly teetotal aunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I,” said Tuppence, “shall be Polton.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy looked at her scornfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Polton indeed. You couldn’t begin to do one of the things that he does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I can,” said Tuppence. “I can rub my hands together when I’m pleased. That’s quite enough to get on with. I hope you’re going to take plaster casts of footprints?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Tommy was reduced to silence. Having collected the corkscrew they went round to the garage, got out the car and started for Wimbledon.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Laurels was a big house. It ran somewhat to gables and turrets, had an air of being very newly painted, and was surrounded with neat flower beds filled with scarlet geraniums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A tall man with a close cropped white moustache, and an exaggeratedly martial bearing opened the door before Tommy had time to ring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been looking out for you,” he explained fussily. “Mr. Blunt, is it not? I am Colonel Kingston Bruce. Will you come into my study?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He led them into a small room at the back of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Young St. Vincent was telling me wonderful things about your firm. I’ve noticed your advertisements myself. This guaranteed twenty—four hours service of yours—a marvelous notion. That’s exactly what I need.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inwardly anathematizing Tuppence for her irresponsibility in inventing this brilliant detail, Tommy replied: “Just so Colonel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The whole thing is most distressing, sir, most distressing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps you would kindly give me the facts,” said Tommy, with a hint of impatience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly I will—at once. We have at the present moment staying with us a very old and dear friend of ours, Lady Laura Barton. Daughter of the late Earl of Carrowway. The present Earl, her brother, made a striking speech in the House of Lords the other day. As I say, she is an old and dear friend of ours. Some American friends of mine who have just come over, the Hamilton Betts, were most anxious to meet her. ‘Nothing easier,’ I said. ‘She is staying with me now. Come down for the weekend.’ You know what Americans are about titles, Mr. Blunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And others besides Americans sometimes, Colonel Kingston Bruce.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“Alas! only too true, my dear sir. Nothing I hate more than a snob. Well, as I was saying, the Betts came down for the week—end. Last night—we were playing Bridge at the time—the clasp of a pendant Mrs. Hamilton Betts was wearing broke, so she took it off and laid it down on a small table, meaning to take it upstairs with her when she went. This, however, she forgot to do. I must explain, Mr. Blunt, that the pendant consisted ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("of two small diamond wings, and a big pink pearl depending from them. The pendant was found this morning lying where Mrs. Betts had left it, but the pearl, a pearl of enormous value, had been wrenched off.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who found the pendant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The parlormaid—Gladys Hill.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any reason to suspect her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She has been with us some years, and we have always found her perfectly honest. But, of course, one never knows—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly. Will you describe your staff, and also tell me who was present at dinner last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is the cook—she has been with us only two months, but then she would have no occasion to go near the drawingroom—the same applies to the kitchen maid. Then there is the housemaid, Alice Cummings. She also has been with us for some years. And Lady Laura’s maid, of course. She is French.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colonel Kingston Bruce looked very impressive as he said this. Tommy, unaffected by the revelation of the maid’s nationality, said: “Exactly. And the party at dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. and Mrs. Betts, ourselves—(my wife and daughter)—and Lady Laura. Young St. Vincent was dining with us, and Mr. Rennie looked in after dinner for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who is Mr. Rennie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A most pestilential fellow—an arrant socialist. Good looking, of course, and with a certain specious power of argument. But a man, I don’t mind telling you, whom I wouldn’t trust a yard. A dangerous sort of fellow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In fact,” said Tommy drily, “it is Mr. Rennie whom you suspect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do, Mr. Blunt. I’m sure, holding the views he does, that he can have no principles whatsoever. What could have been easier for him than to have quietly wrenched off the pearl at a moment when we were all absorbed in our game? There were several absorbing moments—a redoubled No Trump hand, I remember, and also a painful argument when my wife had the misfortune to revoke.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“Quite so,” said Tommy. “I should just like to know one thing—what is Mrs. Bett’s attitude in all this?”")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wanted me to call in the police,” said Colonel Kingston Bruce reluctantly. “That is, when we had searched everywhere in case the pearl had only dropped off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you dissuaded her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was very averse to the idea of publicity and my wife and daughter backed me up. Then my wife remembered young St. Vincent speaking about your firm at dinner last night—and the twenty—four hours special service.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” said Tommy with a heavy heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see, in any case no harm will be done. If we call in the police tomorrow, it can be supposed that we thought the jewel merely lost and were hunting for it. By the way, nobody has been allowed to leave the house this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except your daughter, of course,” said Tuppence, speaking for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Except my daughter,” agreed the Colonel. “She volunteered at once to go and put the case before you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We will do our best to give you satisfaction, Colonel,” he said. “I should like to see the drawing—room, and the table on which the pendant was laid down. I should also like to ask Mrs. Betts a few questions. After that, I will interview the servants—or rather my assistant, Miss Robinson, will do so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He felt his nerve quailing before the terrors of questioning the servants. Colonel Kingston Bruce threw open the door, and led them across the hall. As he did so, a remark came to them clearly through the open door of the room they were approaching, and the voice that uttered it was that of the girl who had come to see them that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know perfectly well, mother,” she was saying, “that she did bring home a teaspoon in her muff.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("In another minute they were being introduced to Mrs. Kingston Bruce, a plaintive lady with a languid manner. Miss Kingston Bruce acknowledged their presence with a short inclination of the head. Her face was more sullen than ever.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Kingston Bruce was voluble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“—but I know who I think took it,” she ended. “That dreadful socialist young man. He loves the Russians and the Germans and hates the English—what else can you expect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He never touched it,” said Miss Kingston Bruce fiercely. “I was watching him—all the time. I couldn’t have failed to see if he had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked at them defiantly with her chin up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy created a diversion by asking for an interview with Mrs. Betts. When Mrs. Kingston Bruce had departed accompanied by her husband and daughter to find Mrs. Betts, he whistled thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder,” he said gently, “who it was who had a teaspoon in her muff?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just what I was thinking,” replied Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Betts, followed by her husband, burst into the room. She was a big woman with a determined voice. Mr. Hamilton Betts looked dyspeptic and subdued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand, Mr. Blunt, that you are a private inquiry agent, and one who hustles things through at a great rate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hustle,” said Tommy, “is my middle name, Mrs. Betts. Let me ask you a few questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thereafter things proceeded rapidly. Tommy was shown the damaged pendant, the table on which it had lain, and Mr. Betts emerged from his taciturnity to mention the value, in dollars, of the stolen pearl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And withal, Tommy felt an irritating certainty that he was not getting on. “I think that will do,” he said at length. “Miss Robinson, will you kindly fetch the special photographic apparatus from the hall?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Robinson complied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A little invention of my own,” said Tommy. “In appearance, you see, it is just like an ordinary camera.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("He had some slight satisfaction in seeing that the Betts were impressed. ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("He photographed the pendant, the table on which it had lain, and took several general views of the apartment. Then “Miss Robinson” was delegated to interview the servants, and in view of the eager expectancy on the faces of Colonel Kingston Bruce and Mrs. Betts, Tommy felt called upon to say a few authoritative words.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“The position amounts to this,” he said. “Either the pearl is still in the house, or it is not still in the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite so,” said the Colonel with more respect than was, perhaps, quite justified by the nature of the remark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it is not in the house, it may be anywhere—but if it is in the house, it must necessarily be concealed somewhere—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And a search must be made,” broke in Colonel Kingston Bruce. “Quite so. I give you carte Blanche, Mr. Blunt. Search the house from attic to cellar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! Charles,” murmured Mrs. Kingston Bruce tearfully. “Do you think that is wise? The servants won’t like it. I’m sure they’ll leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We will search their quarters last,” said Tommy soothingly. “The thief is sure to have hidden the gem in the most unlikely place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I seem to have read something of the kind,” agreed the Colonel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite so,” said Tommy. “You probably remember the case of Rex. v. Bailey which created a precedent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh—er—yes,” said the Colonel looking puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, the most unlikely place is in the apartments of Mrs. Betts,” continued Tommy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My! Wouldn’t that be too cute?” said Mrs. Betts admiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without more ado, she took him up to her room where Tommy once more made use of the special photographic apparatus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently Tuppence joined him there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have no objection, I hope, Mrs. Betts, to my assistant’s looking through your wardrobe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, not at all. Do you need me here any longer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy assured her that there was no need to detain her, and Mrs. Betts departed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“We might as well go on bluffing it out,” said Tommy. “But personally I don’t believe we’ve a dog’s chance of finding the thing. Curse you and your twenty—four hours stunt, Tuppence.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen,” said Tuppence. “The servants are all right, I’m sure, but I managed to get something out of the French maid. It seems that when Lady Laura was staying here a year ago, she went out to tea with some friends of the Kingston Bruces’, and when she got home a teaspoon fell out of her muff. Everyone thought it must have fallen in by accident.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But, talking about similar robberies, I got hold of a lot more. Lady Laura is always staying about with people. She hasn’t got a bean, I gather, and she’s out for comfortable quarters with people to whom a title still means something. It may be a coincidence—or it may be something more, but five distinct thefts have taken place whilst she has been staying in various houses, sometimes trivial things, sometimes valuable jewels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whew!” said Tommy, and gave vent to a prolonged whistle. “Where’s the old bird’s room, do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just across the passage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I think, I rather think, that we’ll just slip across and investigate.” The room opposite stood with its door ajar. It was a spacious apartment, with white enameled fitments and rose pink curtains. An inner door led to a bathroom. At the door of this appeared a slim dark girl, very neatly dressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuppence checked the exclamation of astonishment on the girl’s lips. “This is Elise, Mr. Blunt,” she said primly. “Lady Laura’s maid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy stepped across the threshold of the bathroom, and approved inwardly its sumptuous and up to date fittings. He set to work to dispel the wide stare of suspicion on the French girl’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are busy with your duties, eh, Mademoiselle Elise?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Monsieur, I clean Milady’s bath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, perhaps you’ll help me with some photography instead. I have a special kind of camera here, and I am photographing the interiors of all the rooms in this house.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("He was interrupted by the communicating door to the bedroom banging suddenly behind him. Elise jumped at the sound.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It must have been the wind,” said Tuppence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We will come into the other room,” said Tommy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elise went to open the door for them, but the door knob rattled aimlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the matter?” said Tommy sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, Monsieur, but somebody must have locked it on the other side.” She caught up a towel and tried again. But this time the door handle turned easily enough, and the door swung open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Voila ce qui est curieux. It must have stuck,” said Elise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no one in the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy fetched his apparatus. Tuppence and Elise worked under his orders. But again and again his glance went back to the communicating door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder,” he said between his teeth. “I wonder why that door stuck?” He examined it minutely, shutting and opening it. It fitted perfectly. “One picture more,” he said with a sigh. “Will you loop back that rose curtain, Mademoiselle Elise? Thank you. Just hold it so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The familiar click occurred. He handed a glass slide to Elise to hold, relinquished the tripod to Tuppence, and carefully readjusted and closed the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made some easy excuse to get rid of Elise, and as soon as she was out of the room, he caught hold of Tuppence and spoke rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look here, I’ve got an idea. Can you hang on here? Search all the rooms—that will take some time. Try and get an interview with the old bird—Lady Laura—but don’t alarm her. Tell her you suspect the parlormaid. But whatever you do, don’t let her leave the house. I’m going off in the car. I’ll be back as soon as I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” said Tuppence. “But don’t be too cocksure. You’ve forgotten one thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“The girl. There’s something funny about that girl. Listen, I’ve found out the time she started from the house this morning. It took her two hours to get to our office. That’s nonsense. Where did she go before she came to us?”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s something in that,” admitted her husband. “Well, follow up any old clue you like, but don’t let Lady Laura leave the house. What’s that?” His quick ear had caught a faint rustle outside on the landing. He strode across to the door, but there was no one to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, so long,” he said. “I’ll be back as soon as I can.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98f0d692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter03.vue
// module id = 81
// module chunks = 0